import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'William Roig',
      date: 'December 15, 2025',
      rating: 5,
      text: "I've had a really great experience with Red Sail Self Storage. The site feels very secure, which gave me real peace of mind from day one. The containers are spotlessly clean and, importantly, completely weatherproof — everything I've stored has stayed dry and in perfect condition regardless of the weather. The whole setup is well maintained and easy to access, and the pricing represents excellent value for money compared with other options I looked at. I wouldn't hesitate to recommend Red Sail Self Storage to anyone looking for safe, clean, and reliable storage at a fair price.",
      image: null,
    },
    {
      name: 'Michael Stow',
      date: '5 months ago',
      rating: 5,
      text: "Been using for over a year now, new, clean and secure. 24 hour access. Highly Recommended.",
      reviews: '12 reviews · 7 photos',
      image: null,
    },
  ];

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center px-4 py-2 rounded-full bg-red-100 text-red-700 text-sm font-medium mb-4">
            <Star className="h-4 w-4 mr-2" />
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600">
            Don't just take our word for it. Here's what our satisfied customers have to say about their storage experience.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="border-2 border-gray-200 hover:border-red-200 hover:shadow-xl transition-all duration-300 relative"
            >
              <CardContent className="p-8">
                {/* Quote Icon */}
                <div className="absolute top-6 right-6 opacity-10">
                  <Quote className="h-16 w-16 text-red-600" />
                </div>

                {/* Rating */}
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 leading-relaxed mb-6 relative z-10">
                  "{testimonial.text}"
                </p>

                {/* Author Info */}
                <div className="flex items-center space-x-4 pt-4 border-t border-gray-200">
                  <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                    <span className="text-red-600 font-bold text-lg">
                      {testimonial.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.date}</p>
                    {testimonial.reviews && (
                      <p className="text-xs text-gray-500">{testimonial.reviews}</p>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Banner */}
        <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-2xl p-8 md:p-12 text-white text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Join Our Satisfied Customers
            </h3>
            <p className="text-lg text-red-100 mb-6">
              Experience the peace of mind that comes with secure, clean, and reliable storage. 
              Our customers trust us with their valuables - you can too.
            </p>
            <div className="flex flex-wrap justify-center gap-8">
              <div className="text-center">
                <div className="flex items-center justify-center mb-2">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-6 w-6 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-red-100">5-Star Reviews</p>
              </div>
              <div className="h-16 w-px bg-red-400" />
              <div className="text-center">
                <p className="text-4xl font-bold mb-2">100+</p>
                <p className="text-red-100">Happy Customers</p>
              </div>
              <div className="h-16 w-px bg-red-400" />
              <div className="text-center">
                <p className="text-4xl font-bold mb-2">100%</p>
                <p className="text-red-100">Satisfaction Rate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
